import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";
import { ApiService } from "./api.service";

interface IPreferenceRequest {
  startTime: string;
  officeGuid: string;
}
@Injectable({
  providedIn: "root"
})
export class PreferenceDataService {
  todayPreferences: Observable<NsEmpWebExpData.IPreference>;
  otherDayPreference: Observable<NsEmpWebExpData.IPreference>;
  constructor(private apiService: ApiService) {}

  refreshReplayStreams(args?: IPreferenceRequest): void {
    let localPreferences = this.apiService.genReplayStream(this.apiService.getEmpPreferences(args));
    this.otherDayPreference = localPreferences;
    if (args && args?.startTime) return;
    this.todayPreferences = localPreferences;
  }
}
